module.exports = __webpack_public_path__ + "static/media/6to10.cf288cff.svg";